"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotFoundComponent = /** @class */ (function () {
    function NotFoundComponent() {
    }
    return NotFoundComponent;
}());
exports.NotFoundComponent = NotFoundComponent;
